import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "report-modal-inner",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "report-modal-header" }
const _hoisted_3 = { class: "report-modal-titles" }
const _hoisted_4 = { class: "report-modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "report-modal-description"
}
const _hoisted_6 = { class: "report-modal-actions" }
const _hoisted_7 = { class: "report-modal-body" }
const _hoisted_8 = {
  key: 1,
  class: "report-modal-error"
}

import { ref, watch, nextTick, onBeforeUnmount } from "vue";
import Loader from "@/components/Loader.vue";
import { usePowerBiEmbed } from "@/composables/reports/usePowerBiEmbed";
import type { ReportEmbedToken, ReportItem } from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportViewerModal',
  props: {
    report: {},
    token: {},
    open: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props;



const container = ref<HTMLDivElement | null>(null);
const { isLoading, error, embed, reset } = usePowerBiEmbed();

function popOut(): void {
  if (props.report) {
    window.open(`/reports/view/${props.report.id}`, "_blank");
  }
}

// Watch both the open flag and the report id so the modal re-embeds when the
// selected report changes (not only when it is first opened). The token is
// already fetched by the parent before the modal opens.
watch(
  () => [props.open, props.report?.id] as const,
  async ([isOpen]) => {
    if (isOpen && props.token) {
      await nextTick();
      if (container.value) {
        embed(container.value, props.token);
      }
    } else {
      reset();
    }
  }
);

onBeforeUnmount(() => {
  reset();
});

return (_ctx: any,_cache: any) => {
  return (__props.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "report-modal-wrapper",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.report?.displayName), 1),
              (__props.report?.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.report?.description), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "report-modal-popout",
                title: "Open in a new tab",
                onClick: popOut
              }, " Pop out ↗ "),
              _createElementVNode("button", {
                type: "button",
                class: "report-modal-close",
                title: "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, " ✕ ")
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_unref(isLoading))
              ? (_openBlock(), _createBlock(Loader, { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(error))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(error)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref_key: "container",
              ref: container,
              class: "report-modal-embed"
            }, null, 512)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})